<div class="wrapper">
    <mat-spinner
        *ngIf="isLoadingSENTGeoActiveStatus"
        class="loader"
        [strokeWidth]="2"
        [diameter]="24"
    ></mat-spinner>

    <ng-container *ngIf="!isLoadingSENTGeoActiveStatus">
        <ng-container *ngIf="isActiveSENTGeo">
            <div class="column-top">
                <div class="switch-sending-data">
                    <div class="switch-sending-data__left-column">
    
                        <ng-container *ngIf="!isTheProcessOfSwitchingOn && (SentGeoCurrentState !== SENT_GEO_STATUS.Waiting || !isSending)">
                            <ng-container *ngIf="isSending">
                                <img src="/assets/img/sent-icon.svg" alt="">
                                <span class="switch-sending-data__left-column__title">
                                    <b>{{ 'sentSending' | translate }}</b>
                                </span>
                            </ng-container>
                
                            <ng-container *ngIf="!isSending">
                                <img src="/assets/images/layout/etoll-not-sending.svg" alt="">
                                <span class="switch-sending-data__left-column__title">
                                    <b>{{ 'sendingDataToSentOff' | translate }}</b> {{ 'dataNoSendTitleSENT' | translate }} {{ 'toSENT' | translate }}
                                </span>
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="isTheProcessOfSwitchingOn">
                            <img src="" alt="">
                            <span class="switch-sending-data__left-column__title">
                                {{ isSending ? ('processingChangeSENTStatusOn' | translate) : ('processingChangeSENTStatusOff' | translate) }}
                            </span>
                        </ng-container>

                        <ng-container *ngIf="SentGeoCurrentState === SENT_GEO_STATUS.Waiting && !isTheProcessOfSwitchingOn && isSending">
                            <img src="/assets/img/delay-sent-geo-status.svg" alt="">
                            <span class="switch-sending-data__left-column__title">
                                <b>{{ 'sentSendDataWithDelay' | translate }}</b>
                            </span>
                        </ng-container>

                    </div>
                    <div class="switch-sending-data__right-column">
                        <div 
                            *ngIf="!isTheProcessOfSwitchingOn"
                            class="switch-sending-data__right-column__wrapper-switch"
                        >
                            <p-inputSwitch
                                [(ngModel)]="isSending"
                                (ngModelChange)="onSwitchChangeValue()"
                                [disabled]="SentGeoCurrentState === SENT_GEO_STATUS.Error"
                                pTooltip="{{isSending ? ('turnOff' | translate) : ('turnOn' | translate)}} {{ 'sendingDataToSENT' | translate }}"
                                tooltipPosition="bottom"
                                tooltipStyleClass="tooltip-pinned"
                            ></p-inputSwitch>
                            <button *ngIf="isSending" (click)="showModalConfirmUnLock()" class="confirm-modal-btn"></button>
                        </div>

                        <p-progressSpinner
                            *ngIf="isTheProcessOfSwitchingOn"
                            strokeWidth="3"
                            [style]="{ width: '20px', height: '20px'}"
                        ></p-progressSpinner>
                    </div>
                </div>
                <div *ngIf="SentGeoCurrentState === SENT_GEO_STATUS.Error" class="error-gps">
                    <span class="error-gps__title">
                        {{'errorGPS'|translate}}
                    </span>
                </div>
                <span *ngIf="lastUpdated" class="last-update-title">
                    {{'lastSend'|translate}}: <b>{{ lastUpdated | statusTimeFormat }}</b>
                </span>
            </div>

            <app-vehicle-business-number-pin [vehicle]="_vehicleData" [title]="'SENTDetailsDataTitle' | translate"></app-vehicle-business-number-pin>
        </ng-container>
    
        <app-sent-tab-no-active-service *ngIf="!isActiveSENTGeo"></app-sent-tab-no-active-service>
    </ng-container>
</div>
